/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/services/navigationhelperservice.ts" />
module App.HiLO.Controllers {
	'use strict';

	class HeadController  {

		public static $inject = ['app.common.services.navigationHelperService'];
		constructor(public navigationHelper: Common.Services.NavigationHelperService) {}

	}

	angular
		.module('app.hilo.controllers')
		.controller('app.hilo.controllers.headController', HeadController);

}